import { useRef, useState } from "react";
import { store } from "src/store/store";
import { getRemainingVideoUsage } from "src/modules/firebase/duck/selectors";
import { setRemainingVideoUsage } from "src/modules/firebase/duck/actions";
import CircularProgress from "src/components/CircularProgress";
import FreemiumVideo from "src/modules/parent-station/FreemiumVideo";
import RoundButton from "../RoundButton";

function FreemiumVideoButton({
  toggleMonitoringMode,
  togglePurchaseFlow,
  background,
  mode,
  StartVideoIcon,
  StopVideoIcon,
  closeCameraList
}) {
  const [isVideoRunning, setIsVideoRunning] = useState(FreemiumVideo.isRunning);
  const videoElementRef = useRef(null);

  function onVideoLoad() {
    videoElementRef.current?.removeEventListener("loadeddata", onVideoLoad);
    videoElementRef.current = null;
    setIsVideoRunning(true);
    FreemiumVideo.start();
  }

  function getVideo() {
    return window.document.querySelector("video");
  }

  async function startVideoWithLimit() {
    const remainingVideoUsage = getRemainingVideoUsage(store.getState());

    if (remainingVideoUsage > 0) {
      await toggleMonitoringMode();
      store.dispatch(setRemainingVideoUsage(remainingVideoUsage - 1));

      const video = getVideo();
      videoElementRef.current = video;
      video.addEventListener("loadeddata", onVideoLoad);
    } else togglePurchaseFlow("unlimitedMonitoringDailyCap");
  }

  async function stopVideo() {
    FreemiumVideo.interrupt();
    setIsVideoRunning(false);
    videoElementRef.current?.removeEventListener("loadeddata", onVideoLoad);
    videoElementRef.current = null;
    await toggleMonitoringMode();
  }

  async function toggleVideoMode() {
    isVideoRunning ? stopVideo() : startVideoWithLimit();
  }

  async function onVideoFinish() {
    setIsVideoRunning(false);
    closeCameraList();
  }

  return (
    <CircularProgress
      onClick={toggleVideoMode}
      progressOnTop={true}
      status={isVideoRunning ? "running" : "hidden"}
      getProgress={FreemiumVideo.getProgress}
      onFinish={onVideoFinish}
      progressTrail={false}
      borderWidth={4}
      size="10.69vmin"
      color="white"
      // mb={["16px", "24px"]}
      mb="3.0534vmin"
    >
      <RoundButton
        bg={background}
        // size={["56px", "72px", "80px"]}
        size="10.69vmin"
        icon={mode === "audio" ? StartVideoIcon : StopVideoIcon}
        iconFill="white"
        iconSize="50%"
      />
    </CircularProgress>
  );
}

export default FreemiumVideoButton;
